// | Wrappers for easier use of the Storage service in Specular widgets.
import * as Restaumatic$dServices$dStorage from "../Restaumatic.Services.Storage/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
const storeValueDyn = dictEncode => () => dictMonadReader => {
  const $0 = dictMonadReader.MonadAsk0();
  const map = $0.Monad0().Bind1().Apply0().Functor0().map;
  const ask1 = $0.ask;
  return dictMonadFRP => {
    const bind = dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind;
    const subscribeDyn_ = Specular$dFRP$dBase.subscribeDyn_(dictMonadFRP);
    return key => dyn => bind(map(v => v.storage)(ask1))(storage => subscribeDyn_(Restaumatic$dServices$dStorage.setJSONItem()(dictEncode)(storage)(key))(dyn));
  };
};
const storeValue = dictEncode => () => dictMonadReader => {
  const $0 = dictMonadReader.MonadAsk0();
  const map = $0.Monad0().Bind1().Apply0().Functor0().map;
  const ask1 = $0.ask;
  return dictMonadFRP => {
    const MonadCleanup1 = dictMonadFRP.MonadCleanup1();
    const bind = MonadCleanup1.Monad0().Bind1().bind;
    const subscribeEvent_ = Specular$dFRP$dBase.subscribeNode(dictMonadFRP.MonadEffect0())(MonadCleanup1);
    return key => change => bind(map(v => v.storage)(ask1))(storage => subscribeEvent_(Restaumatic$dServices$dStorage.setJSONItem()(dictEncode)(storage)(key))(change));
  };
};
const storeSessionValue = dictEncode => () => dictMonadReader => {
  const $0 = dictMonadReader.MonadAsk0();
  const map = $0.Monad0().Bind1().Apply0().Functor0().map;
  const ask1 = $0.ask;
  return dictMonadFRP => {
    const MonadCleanup1 = dictMonadFRP.MonadCleanup1();
    const bind = MonadCleanup1.Monad0().Bind1().bind;
    const subscribeEvent_ = Specular$dFRP$dBase.subscribeNode(dictMonadFRP.MonadEffect0())(MonadCleanup1);
    return key => change => bind(map(v => v.sessionStorage)(ask1))(storage => subscribeEvent_(Restaumatic$dServices$dStorage.setJSONItem()(dictEncode)(storage)(key))(change));
  };
};
const readStoredValue = dictDecode => {
  const getJSONItem1 = Restaumatic$dServices$dStorage.getJSONItem()(dictDecode);
  return () => dictMonadReader => {
    const $0 = dictMonadReader.MonadAsk0();
    const map = $0.Monad0().Bind1().Apply0().Functor0().map;
    const ask1 = $0.ask;
    return dictMonadEffect => {
      const bind = dictMonadEffect.Monad0().Bind1().bind;
      return key => bind(map(v => v.storage)(ask1))(storage => dictMonadEffect.liftEffect(getJSONItem1(storage)(key)));
    };
  };
};
const readSessionStoredValue = dictDecode => {
  const getJSONItem1 = Restaumatic$dServices$dStorage.getJSONItem()(dictDecode);
  return () => dictMonadReader => {
    const $0 = dictMonadReader.MonadAsk0();
    const map = $0.Monad0().Bind1().Apply0().Functor0().map;
    const ask1 = $0.ask;
    return dictMonadEffect => {
      const bind = dictMonadEffect.Monad0().Bind1().bind;
      return key => bind(map(v => v.sessionStorage)(ask1))(storage => dictMonadEffect.liftEffect(getJSONItem1(storage)(key)));
    };
  };
};
export {readSessionStoredValue, readStoredValue, storeSessionValue, storeValue, storeValueDyn};
